<div
  class="d-flex justify-content-between align-items-center pointer {{ isOpen ? contentExpandClass : '' }}"
  (click)="togglePanel()"
>
  <h2 class="mb-0 {{ titleClass }}">{{ title | translate }}</h2>
  <i
    class="fa-solid"
    [ngClass]="isOpen ? 'fa-angle-up' : 'fa-angle-down'"
  ></i>
</div>
<div *ngIf="isOpen">
  <ng-content></ng-content>
</div>
